'use client';

import Header from '../../components/common/Header';
import PromotionTabs from './PromotionTabs';
import Banner1 from '../../assets/images/Banner-1.webp';
import Banner2 from '../../assets/images/Banner-2.webp';
import Banner3 from '../../assets/images/Banner-3.webp';
import Banner4 from '../../assets/images/Banner-4.webp';
import Banner5 from '../../assets/images/Banner-5.webp';

export default function PromotionsPage() {
  const promotionTabs = [
    {
      id: 'all',
      title: 'All',
      content: (
        <div className='space-y-2.5'>
          <div className='rounded-lg overflow-hidden bg-yellow-400 '>
            <img src={Banner1} className='w-full h-auto ' />
          </div>
          <div className='rounded-lg overflow-hidden bg-pink-400'>
            <img src={Banner2} className='w-full h-auto' />
          </div>
          <div className='rounded-lg overflow-hidden bg-purple-500'>
            <img src={Banner3} className='w-full h-auto' />
          </div>
          <div className='rounded-lg overflow-hidden bg-yellow-500'>
            <img src={Banner4} className='w-full h-auto' />
          </div>
          <div className='rounded-lg overflow-hidden bg-yellow-500'>
            <img src={Banner5} className='w-full h-auto' />
          </div>
        </div>
      ),
    },
    {
      id: 'deposit',
      title: 'Deposit',
      content: <p>Exclusive promotions for deposits coming soon!</p>,
    },
    {
      id: 'ranking',
      title: 'Ranking',
      content: <p>See the top ranked players here!</p>,
    },
    {
      id: 'others',
      title: 'Others',
      content: <p>Other exciting promotions here!</p>,
    },
  ];

  return (
    <>
      <div className='min-h-screen  relative overflow-hidden '>
        <Header title='Promotion' />

        <PromotionTabs tabs={promotionTabs}></PromotionTabs>
      </div>
    </>
  );
}
